import React from "react";
import { Input } from "reactstrap";
export default (function (props) {
  var value = props.value,
    setValue = props.setValue,
    config = props.config,
    valueFormat = props.valueFormat,
    use12Hours = props.use12Hours,
    readonly = props.readonly;
  var onChange = function onChange(e) {
    var value = e.target.value;
    if (value == "") value = undefined;
    setValue(value);
  };
  return /*#__PURE__*/React.createElement(Input, {
    type: "time",
    bsSize: "sm",
    value: value || "",
    disabled: readonly,
    onChange: onChange
  });
});